import { useNavigate } from "react-router-dom";
import { getSettings } from "store/slices";
import { useAppSelector } from "store/hooks";
import { useState } from "react";
import { t } from "i18next";
import { Input } from "antd";
import { useModal } from "context/hooks/useModal";
import OutlinedButton from "components/common/Button/OutlinedButton";
import Loader from "components/Loader";
import axiosInstance from "utils/axios";
import { formatMessage, useSearch } from "utils/utility";
import { encrypt } from "utils/crypto";
import RenderTermsAndPrivacy from "./RenderTermsAndPrivacy";

const GoogleRegister = ({ values }) => {
  const { dir } = useAppSelector(getSettings);
  const navigate = useNavigate();

  const [inputVales, setInputValues] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone_number: "",
    error: "",
    notification: "",
    loading: false,
    termsAndPolicyChecked: false,
    ...values,
  });

  const queryDetails = useSearch();

  const { showModal, hideModal } = useModal();

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!inputVales.phone_number.trim()) {
      setInputValues({
        ...inputVales,
        error: t("registerFillAllFields"),
      });
      return;
    }

    const phoneRegex =
      /^(?:(?:(\+?972|\(\+?972\)|\+?\(972\))(?:\s|\.|-)?([1-9]\d?))|(0[23489]{1})|(0[57]{1}[0-9]))(?:\s|\.|-)?([^0\D]{1}\d{2}(?:\s|\.|-)?\d{4})$/;

    if (!phoneRegex.test(inputVales.phone_number)) {
      setInputValues({
        ...inputVales,
        error: t("registerPhoneInvalid"),
      });
      return;
    }

    const validPhoneRegex =
      /^05(0\d{3}\d{4}|1(2\d{2}|5\d{2})\d{4}|2\d{3}\d{4}|3\d{3}\d{4}|4\d{3}\d{4}|5(2\d{2}|33\d|32\d|440|441|410|442|43\d|5\d{2}|55\d|6\d{2}|7\d{2}|8\d{2}|9\d{2}|77\d)\d{4}|8\d{3}\d{4})$/;

    if (!validPhoneRegex.test(inputVales.phone_number)) {
      setInputValues({
        ...inputVales,
        error: t("phoneForbidden"),
      });
      return;
    }

    if (!inputVales.termsAndPolicyChecked) {
      setInputValues({
        ...inputVales,
        error: t("registerAgreeToTerms"),
      });
      return;
    }

    setInputValues({
      ...inputVales,
      loading: true,
      error: "",
      notification: "",
    });

    const apiPayload = {
      first_name: inputVales.firstName,
      last_name: inputVales.lastName,
      email: inputVales.email,
      phone_number: inputVales.phone_number,
      loginType: "google",
      quiz: localStorage.getItem("quiz"),
      queryDetails
    };

    axiosInstance
      .post("users/register", { data: encrypt(apiPayload) })
      .then((res) => res.data)
      .then((data) => {
        if (data.statusCode === 201) {
          setInputValues({
            ...inputVales,
            notification: t("registerSuccessMessage"),
            error: "",
            loading: false,
          });
          // const decDetails = decrypt(data.data);
          // setUser(decDetails.token);
          // localStorage.setItem("token", decDetails.token);
          // localStorage.setItem("session", decDetails.session_id);
          // navigate(`/response-form/${decDetails._id}`);
          sessionStorage.setItem("phone_number", inputVales.phone_number);
          navigate("/user-auth/verify-phone");
          hideModal();
        } else {
          setInputValues({
            ...inputVales,
            error: formatMessage(data.message),
            notification: "",
            loading: false,
          });
        }
      })
      .catch((error) => {
        setInputValues({
          ...inputVales,
          error: formatMessage(
            error.response.data.message ?? "someThingWentWrong"
          ),
          loading: false,
          notification: "",
        });
      });
  };

  return (
    <>
      <Loader open={inputVales.loading} type="block" className="rounded-lg" position="portal" />
      <div className="max-h-[90vh] md:max-h-[70vh] overflow-y-auto flex flex-col">
        <button
          className="rounded-full border border-black w-6 h-6 ml-auto"
          onClick={hideModal}
        >
          X
        </button>
        <div
          className="flex flex-col max-w-sm w-full px-6 md:px-0 mx-auto"
          dir={dir}
        >
          <h1 className="text-center text-theme-blue text-2xl mb-3 font-bold">
            {t("registerWithGooglePopupTitle")}
          </h1>
          <div className="flex flex-col gap-4 mb-6">
            <h1
              className="text-xl text-center"
              dangerouslySetInnerHTML={{
                __html: t("welcomePersonalTitle", {
                  firstName: inputVales.firstName,
                }),
              }}
            ></h1>
            {inputVales.error && (
              <p className="text-red-500 text-xs italic">
                {inputVales.error ?? t("someThingWentWrong")}
              </p>
            )}

            {inputVales.notification && (
              <p className="text-green-500 text-xs italic">
                {inputVales.notification || ""}
              </p>
            )}
            {/* <Input
              id="first_name"
              type="text"
              placeholder={t("signupPageFirstNamePlaceholder")}
              value={inputVales.firstName}
              onChange={(e) =>
                setInputValues({ ...inputVales, firstName: e.target.value })
              }
              className="text-lg py-1"
            /> */}
            {/* <Input
              id="last_name"
              type="text"
              placeholder={t("signupPageLastNamePlaceholder")}
              value={inputVales.lastName}
              onChange={(e) =>
                setInputValues({ ...inputVales, lastName: e.target.value })
              }
              className="text-lg py-1"
            /> */}
            <div dir="ltr">
              <Input
                dir="ltr"
                id="phone"
                type="number"
                addonBefore="+972"
                placeholder={"05XXXXXXXX"}
                value={inputVales.phone_number}
                onChange={(e) => {
                  const regex = /^\d{0,10}$/;
                  if (
                    regex.test(e.target.value) &&
                    !e.target.value.includes("-")
                  ) {
                    setInputValues({
                      ...inputVales,
                      phone_number: e.target.value,
                    });
                  }
                }}
                className="phone-input text-lg py-1"
                size="large"
              />
            </div>
            <div className="flex items-center justify-start gap-2" dir={dir}>
              <input
                type="checkbox"
                id="privacy"
                checked={inputVales.termsAndPolicyChecked}
                onChange={(event) => {
                  setInputValues({
                    ...inputVales,
                    termsAndPolicyChecked: event.target.checked,
                  });
                }}
                className="cursor-pointer"
              />
              <label
                className="text-xs"
                onClick={() => {
                  setInputValues({
                    ...inputVales,
                    termsAndPolicyChecked: !inputVales.termsAndPolicyChecked,
                  });
                }}
              >
                {t("termsAndPrivacy.IAgree")}&nbsp;
                <span
                  className="underline cursor-pointer"
                  onClick={(e) => {
                    e.stopPropagation();
                    showModal(
                      <RenderTermsAndPrivacy url="https://link.nexme.ai/terms" />,
                      "md"
                    );
                  }}
                >
                  {t("termsAndPrivacy.TermsFfUse")}
                </span>
                &nbsp;
                {t("termsAndPrivacy.and")}&nbsp;
                <span
                  className="underline cursor-pointer"
                  onClick={(e) => {
                    e.stopPropagation();
                    showModal(
                      <RenderTermsAndPrivacy url="https://link.nexme.ai/privacy" />,
                      "md"
                    );
                  }}
                >
                  {t("termsAndPrivacy.privacyPolicy")}
                </span>
                &nbsp;
                {t("termsAndPrivacy.reachByConsultant")}
              </label>
            </div>
          </div>
          <div className="flex flex-col items-center justify-center w-full">
            <OutlinedButton 
              onClick={handleSubmit}
              disabled={
                !inputVales.phone_number ||
                inputVales.phone_number.length !== 10 ||
                !inputVales.termsAndPolicyChecked
              }
              className="bg-gradient-to-r from-amber-500 to-yellow-500 hover:from-amber-600 hover:to-yellow-600 text-gray-900 py-3 w-full font-semibold transition-all duration-200 flex items-center justify-center rounded-xl shadow-lg hover:shadow-xl disabled:!bg-gray-300 disabled:!from-gray-300 disabled:!to-gray-400 disabled:text-gray-500 disabled:cursor-not-allowed disabled:shadow-none"
            >
              {t("registerButton")}
            </OutlinedButton>
          </div>
        </div>
      </div>
    </>
  );
};

export default GoogleRegister;
